/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharemonthcredits2Inputs */

const en_sharemonthcredits2 = /** @type {(inputs: Sharemonthcredits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`credits this month`)
};

const de_sharemonthcredits2 = /** @type {(inputs: Sharemonthcredits2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits diesen Monat`)
};

/**
* | output |
* | --- |
* | "credits this month" |
*
* @param {Sharemonthcredits2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharemonthcredits2 = /** @type {((inputs?: Sharemonthcredits2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharemonthcredits2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharemonthcredits2(inputs)
	return de_sharemonthcredits2(inputs)
});
export { sharemonthcredits2 as "shareMonthCredits" }